<template lang="pug">
  v-app.App(@error="setError")
    Error(v-if="error" :error.sync="error")
    v-snackbar(value="true" v-if="isIE()" color="error" top :timeout="0")
      b.mr-1 Attenzione
      | Stai utilizzando un browser non supportato. Cambialo per continuare ad usare il sito.
    v-snackbar(v-model="showLogoutSnackbar" color="success" top :timeout="3000")
      | Hai effettuato il logout
    template(v-if="offline")
      v-container(fill-height)
        v-layout(justify-center align-center)
          v-alert(:value="offline" type="error")
            | Sei offline. Riconnettiti per continuare ad utilizzare l'applicazione.
    template(v-else-if="loading || !$auth.ready")
      v-container(fill-height)
        Loading
    template(v-else)
      AddToHomeIOSSafariDialog
      // alert message dialog
      v-app-bar(app color="primary" dark dense)
        template(v-if="$route.name == 'explore'")
          img.mr-1(src="/logo.public.jpg" height="40rem")
          v-toolbar-title.pl-0 OpenList
        template(v-else)
          v-btn(icon @click="routerGoBack" data-cy="button_goBack" v-if="!['explore', 'profile', 'profile.reservations'].includes($route.name)")
            v-icon mdi-arrow-left
          v-toolbar-title.pl-0(data-cy="title") {{ title }}
        v-spacer
        v-btn(icon :to="{ name: 'profile' }" exact)
          v-icon mdi-account-circle
      v-content.App__content.grey.lighten-3
        transition(name="router-anim")
          router-view.App__router-view(:title.sync="title" @logout="handleLogout()" ref="view")
      v-bottom-navigation.BottomNav(app :value="$route.name")
        v-btn(style="display:none")
        v-btn.px-2.flex-grow-1.flex-shrink-1(exact text value="explore" color="primary" :to="{ name:'explore' }")
          span Esplora
          v-icon mdi-compass
        v-btn.px-2.flex-grow-1.flex-shrink-1(exact text value="profile.reservations" color="primary" :to="{ name:'profile.reservations' }")
          span Prenotazioni
          v-icon mdi-ticket
</template>

<script>
import Error from "@/components/Error";
import Loading from "@/components/Loading";
import AddToHomeIOSSafariDialog from "@/components/AddToHomeIOSSafariDialog";
import ClientToken from "@/auth/ClientToken";
export default {
  name: "App",
  components: { Error, Loading, AddToHomeIOSSafariDialog },

  data: () => ({
    title: "Caricamento...",
    loading: true,
    offline: !navigator.onLine,
    error: null,
    showLogoutSnackbar: false
  }),

  computed: {},

  watch: {
    title(title) {
      // set document title
      document.title = `${title} - Openlist`;
    }
  },

  async created() {
    await this.$auth.start();
  },

  async mounted() {
    try {
      await new ClientToken("bookinglist_public", "bookinglist:app").request();
    } catch (error) {
      this.setError(error);
      return;
    }

    window.addEventListener("online", this.updateConnectionStatus);
    window.addEventListener("offline", this.updateConnectionStatus);
    this.loading = false;
  },

  errorCaptured(error) {
    this.setError(error);
  },

  methods: {
    setError(error) {
      this.error = error;
    },

    routerGoBack() {
      if (this.$refs.view.goBack) {
        this.$refs.view.goBack();
        return;
      }
      if (window.history.length > 0) {
        this.$router.go(-1);
        return;
      }

      this.$router.push({ name: "explore" });
    },

    updateConnectionStatus() {
      this.offline = !navigator.onLine;
    },

    handleLogout() {
      this.showLogoutSnackbar = true;
      this.$router.replace({ name: "explore" });
    },

    isIE() {
      const ua = window.navigator.userAgent; // Check the userAgent property of the window.navigator object
      const msie = ua.indexOf("MSIE "); // IE 10 or older
      const trident = ua.indexOf("Trident/"); // IE 11

      return msie > 0 || trident > 0;
    }
  }
};
</script>

<style lang="scss">
.router-anim-enter-active {
  animation: coming 0.2s;
  animation-delay: 0.25s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 0.2s;
}

@keyframes going {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.h-100 {
  height: 100%;
}

a.clean {
  text-decoration: none;
  color: inherit !important;
}

.cursor-pointer {
  cursor: pointer;
}

.fake-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}

.rounded {
  border-radius: 4px;
}

.QRCode {
  svg {
    height: auto;
    width: 15rem;
    max-width: 100%;
  }
}
</style>
